import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import baseUrl from "../../API/BaseUrl";

const initialState = {
    addFavorite: [],
    removeFavorite: [],
    getAllFavoriteProducts: [],
    isLoading: true,
    isSuccess: true,
    errorMessage: ""
}

// add product to favorite
export const AddFavorite = createAsyncThunk("product/addFav", async (data) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.post("/api/v1/wishlist", data, config);
        return res;
    } catch (error) {
        return error;
    }
})

// remove product from favorite
export const removeProductFromFavorite = createAsyncThunk("product/removeFav", async (id) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.delete(`/api/v1/wishlist/${id}`, config);
        return res;
    } catch (error) {
        return error;
    }
})

// get all  favorite product 
export const getAllFavoriteList = createAsyncThunk("favoriteProduct/getall", async () => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.get("/api/v1/wishlist", config);
        return res;
    } catch (error) {
        return error;
    }
})

const FavoriteSlice = createSlice({
    name: "Favorite",
    initialState,
    reducers: {},
    extraReducers: {
        [AddFavorite.pending]: (state, action) => {
            state.isLoading = true;
        },
        [AddFavorite.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.addFavorite = action.payload;
        },
        [AddFavorite.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        },
        [removeProductFromFavorite.pending]: (state, action) => {
            state.isLoading = true;
        },
        [removeProductFromFavorite.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.removeFavorite = action.payload;
        },
        [removeProductFromFavorite.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        },
        [getAllFavoriteList.pending]: (state, action) => {
            state.isLoading = true;
        },
        [getAllFavoriteList.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.getAllFavoriteProducts = action.payload;
        },
        [getAllFavoriteList.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        },
    }
})

export default FavoriteSlice.reducer;